import {NODE_ENV, PROD_URL} from 'process.env';

const AuthProvider = {
    getIframeWrapperElement: () => document.querySelector('#iframe-wrapper'),
    init:() => {
        const iframeElement = AuthProvider.getIframeWrapperElement();
        if (iframeElement === null) return
        const xmlDomain = NODE_ENV === 'development' ? 'http://localhost:3000' : `https://${PROD_URL}`;
        iframeElement.setAttribute('data-domain', xmlDomain);
    }
}

export default AuthProvider;
